import React from "react";
import { IonButton } from "@ionic/react";
import { IEvidence } from "@interfaces/Interfaces";
import * as ProgramUtils from "@utils/programUtils";

type Props = {
  evidence: IEvidence;
  expiryDays?: number;
  onDone: () => void;
};

const formatExpiry = (days: number): string => {
  if (days % 7 === 0) {
    const weeks = days / 7;
    return `${weeks} ${weeks === 1 ? "week" : "weeks"}`;
  }
  return `${days} ${days === 1 ? "day" : "days"}`;
};

const UOCSubmitConfirmation: React.FC<Props> = ({ evidence, expiryDays, onDone }) => {
  const pedName = ProgramUtils.getUOCPEdName(evidence);
  const pedEmail = ProgramUtils.getUOCPEdEmail(evidence);

  return (
    <div className="pb-safe-area-b flex min-h-full flex-col justify-between">
      <div className="flex flex-col items-center px-safe-area-l pl-safe-area-l pr-safe-area-r pt-8">
        <div className="w-full max-w-app-column">
          <div className="readEvidenceBlock !mt-0">
            <div className="readEvidenceHeader !text-acc-20px">{"Evidence submitted"}</div>
            <div className="flex flex-col gap-3 text-acc-14px font-acc-500 leading-default tracking-default text-grey-70">
              <div className="first-line:mt-0">
                {pedName && pedEmail ? (
                  <>
                    {"Your evidence has been sent to "}
                    <span className="font-acc-700">{pedName}</span>
                    {" at "}
                    <span className="font-acc-700">{pedEmail}</span>
                    {"."}
                  </>
                ) : (
                  <>
                    {"Your evidence has been sent to "}
                    <span className="font-acc-700">{"your Practice Educator"}</span>
                    {"."}
                  </>
                )}
              </div>
              <div className="mt-1 text-acc-14px font-acc-500 leading-default tracking-default text-grey-70">
                {"They will receive an email requesting them to complete the evidence."}
              </div>
            </div>
            <div className="mt-4 h-px w-full bg-grey-30" />
          </div>
          <div className="readEvidenceBlock">
            <div className="flex flex-col gap-3 text-acc-14px font-acc-500 leading-default tracking-default text-grey-70">
              <div>
                {"Evidence is set as "}
                <span className="font-acc-700">{"'Pending'"}</span>
                {" until the Practice Educator reviews it."}
              </div>
              <div>{`Evidence will expire ${expiryDays ? formatExpiry(expiryDays) : "3 weeks"} after you send it.`}</div>
              <div>
                {"You can remind the Practice Educator by viewing the evidence and tapping the "}
                <span className="font-acc-700">{"'Remind PEd'"}</span>
                {" button."}
              </div>
            </div>
          </div>
        </div>
      </div>
      <IonButton
        mode="ios"
        className="mb-8 flex w-full max-w-button self-center"
        onClick={onDone}
      >
        {"Dismiss"}
      </IonButton>
    </div>
  );
};

export default UOCSubmitConfirmation;
